import React from 'react';

import { mediaBreakpoints, spacing } from '~/src/dash/components/layout/common';
import { Row, Rows, Span, Text, usePanel } from '~/src/dash/publicaUI';

export const PanelSizeTracker = () => {
  const { panelSize, width, height } = usePanel();
  const min = panelSize ? mediaBreakpoints[panelSize][0] : 0;
  const max = panelSize ? mediaBreakpoints[panelSize][1] : 0;

  return (
    <Rows>
      <Row>
        <Text subheader>Panel Dimensions</Text>
      </Row>
      <Row noVerticalPadding>
        <Text>
          <Span bold>Panel Width:</Span> {width || 'undefined'}
        </Text>
      </Row>
      <Row noVerticalPadding>
        <Text>
          <Span bold>Panel Height:</Span> {height || 'undefined'}
        </Text>
      </Row>
      <Row noVerticalPadding>
        <Text>
          <Span bold>Panel Size:</Span>{' '}
          <Span highlighted bold>
            '{panelSize || 'undefined'}'
          </Span>
        </Text>
      </Row>
      <Row paddingTop={spacing.none} paddingBottom={spacing.large}>
        <Text>
          <Span bold>Breakpoint Range:</Span> {min}px - {max}px
        </Text>
      </Row>
    </Rows>
  );
};
